import { defineMessages } from 'react-intl';
export default defineMessages({
  drawerTitle: {
    id: 'wishlist.lists.menu.drawerTitle',
    defaultMessage: 'Seznam "{listName}"',
  },
  renameList: {
    id: 'wishlist.lists.menu.renameList',
    defaultMessage: 'Přejmenovat seznam',
  },
  moveOrDelete: {
    id: 'wishlist.lists.menu.moveOrDeleteProducts',
    defaultMessage: 'Přesunout/odstranit produkty v seznamu',
  },
  addAllToCard: {
    id: 'wishlist.lists.menu.addAllToCart',
    defaultMessage: 'Přidat všechny produkty do košíku',
  },
  share: {
    id: 'wishlist.lists.menu.share',
    defaultMessage: 'Sdílet',
  },
  delete: {
    id: 'wishlist.lists.menu.deleteList',
    defaultMessage: 'Smazat seznam',
  },
  deleteDrawerTitle: {
    id: 'wishlist.lists.menu.deleteList.drawerTitle',
    defaultMessage: 'Opravdu chcete seznam smazat?',
  },
  deleteDrawerText: {
    id: 'wishlist.lists.menu.deleteList.drawerText',
    defaultMessage:
      'Chystáte se smazat celý seznam. Jakmile zmizí, už ho nelze vrátit zpět.',
  },
  deleteDrawerYesButton: {
    id: 'wishlist.lists.menu.deleteList.drawerYesButton',
    defaultMessage: 'Ano, chci smazat',
  },
  deleteDrawerNoButton: {
    id: 'wishlist.lists.menu.deleteList.drawerNoButton',
    defaultMessage: 'Ne, děkuji',
  },
  renameListLabel: {
    id: 'wishlist.lists.menu.renameList.inputLabel',
    defaultMessage: 'Nové jméno seznamu',
  },
  shareListDrawerText: {
    id: 'wishlist.lists.menu.shareList.drawerText',
    defaultMessage: 'Odkaz na sdileni',
  },
  addAllToCartDrawerText: {
    id: 'wishlist.lists.menu.addAllToCart.drawerText',
    defaultMessage: 'Chystate se pridat cely obsah seznamu do košíku.',
  },
  addAllToCartDrawerYesButton: {
    id: 'wishlist.lists.menu.addAllToCart.drawerYesButton',
    defaultMessage: 'Ano, chci pridat',
  },
  addAllToCartDrawerNoButton: {
    id: 'wishlist.lists.menu.addAllToCart.drawerNoButton',
    defaultMessage: 'Ne, děkuji',
  },
  addAllToCartProffesionalProductsWarningTitle: {
    id: 'wishlist.lists.menu.addAllToCart.profesionalProductsWarningTitle',
    defaultMessage: 'V seznamu máte profesionální produkt',
  },
});

export const listNotificationMessages = defineMessages({
  itemsAddedToCard: {
    id: 'wishlist.lists.menu.addAllToCart.successNotification',
    defaultMessage:
      'Vsechny dostupne produkty ze seznamu byly přidány do košíku.',
  },
  listRenamed: {
    id: 'wishlist.lists.menu.rename.successNotification',
    defaultMessage: 'Seznam byl prejmenovan',
  },
  listDeleted: {
    id: 'wishlist.lists.menu.delete.successNotification',
    defaultMessage: 'Seznam byl trvale odstraněn.',
  },
});
